import { useCookie } from '@flywire/react-hooks';
import { PERMANENT_COOKIE_NAME } from '@packages/domain/constants/cookies';
import { useLocation } from 'hooks';
import { Ada } from './components/Ada/Ada';

export const Chat = () => {
  const { location } = useLocation();
  const [fingerprint] = useCookie(PERMANENT_COOKIE_NAME, '');

  return <Ada country={location?.countryCode} fingerprint={fingerprint} />;
};
